import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className, delay = 0, y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, testid }) => (
  <div className="mb-12 sm:mb-16 max-w-3xl">
    <Reveal>
      <p className="font-display text-xs sm:text-sm font-bold tracking-[0.3em] uppercase text-brand mb-4">
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testid}
        className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-white leading-[1.05]"
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-muted2">{sub}</p>
      </Reveal>
    )}
  </div>
);
